import React from 'react';
import classNames from 'classnames';
import './TextItem.less';

interface ITextItemProps extends React.HTMLProps<HTMLSpanElement> {
  children: string;
}

const getClassName = (className?: string) => classNames('tt-text-item', className);

/**
 * Text item displays given text. Supposed to standardize not editable text across truth table.
 * It can be used to show not editable content and labels in header cells.
 * If you need to provide ability to edit text look at [[EditablTextItem]]
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const TextItem = React.forwardRef(
  ({ children, className, ...other }: ITextItemProps, ref: React.Ref<HTMLButtonElement>) => {
    return (
      <span ref={ref} title={children} className={getClassName(className)} {...other}>
        {children}
      </span>
    );
  }
);
